package com.wintermar.inspection.core.ui.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun HorizontalLabelValue(
    label: String,
    value: String,
    modifier: Modifier = Modifier,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    Column(
        modifier = modifier.fillMaxWidth()
    ) {
        Spacer(modifier = Modifier.height(dimension.spacing.space4))
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(
                space = dimension.spacing.space4
            )
        ) {
            TextBodySmall(
                text = label,
                color = { it.subtle },
                modifier = Modifier.weight(1f)
            )

            TextBodySmall(
                text = value,
                textAlign = TextAlign.End,
                modifier = Modifier.weight(1f)
            )
        }
        Spacer(modifier = Modifier.height(dimension.spacing.space4))
        HorizontalDivider(
            modifier = Modifier.fillMaxWidth(),
            color = LocalAppTheme.current.color.border.subtle
        )
    }
}
